module.exports = __webpack_public_path__ + "img/measurement_info_left_elbows.d7207e1c.jpg";